var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-render',{ref:"tableRender",attrs:{"config":_vm.config,"height":"45vh","width":"80vw","rowKey":"orderNumber"}}),_vm._v(" "),_c('the-footer',{attrs:{"params":_vm.delParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }